











import {Component, Prop} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import LadingForm from "@/modules/ladings/Form/index.vue";
import LadingTable from "@/modules/ladings/List/components/Table.vue";
import {LadingStore} from "@/modules/ladings/store";
import LadingSearchForUpdate from "@/modules/ladings/List/components/SearchForUpdate.vue";
import LadingUpdateForm from "@/modules/ladings/Form/update.vue";
// Component.registerHooks([
//     'beforeRouteLeave'
// ])

@Component({
  name: "LadingFormUpdate",
  components: {LadingUpdateForm, LadingSearchForUpdate, LadingTable, LadingForm},
})
export default class extends mixins(CommonMixin) {
  @Prop() readonly id!: string;

  ladingId = null;

  // beforeRouteLeave(to, from, next) {
  //     if (LadingStore.isDirtyForm) {
  //         const answer = window.confirm("Dữ liệu thay đổi chưa được lưu, bạn muốn chuyển trang ?");
  //         if (answer) {
  //             next();
  //         } else {
  //             next(false);
  //         }
  //     } else {
  //         next();
  //     }
  // }

  created() {
    // const params = {...new LadingParams()};
    // LadingStore.updateLadingParams(params);
    // LadingStore.listLadingNeedUpdate({...LadingStore.params});
  }

  mounted() {
    this.ladingId = this.id as any;
  }

  get showDetailLading() {
    return !!this.id;
  }

  handleUpdateLading(val: any) {
    this.ladingId = val;
  }
}
